export const agentMonitor = {
  getAgentMonitorDataUrl: "/dialer/agentStatus",
  getAgentMonitorStatusUrl: "/dialer/agent/agentStatus",
};
